<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_error === true">ลบใบส่งคืนสินค้าเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="datalist" :footer-props="footer_Props" :search="search"
            mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.doc_no }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>{{ diffTH(dataDetail.item.return_date) }}</td>
                <!--                <td>{{ dataDetail.item.return_date }}</td>-->
                <td>
                  <div v-if="dataDetail.item.status === ''" style="color: red">ไม่พบข้อมูล</div>
                  <div v-if="dataDetail.item.status === 0" style="color: #fdac39">กำลังดำเนินการ</div>
                  <div v-if="dataDetail.item.status === 1" style="color: #2d78ff">ส่งคืนแล้ว</div>
                  <div v-if="dataDetail.item.status === 2" style="color: #86bc3a">ได้รับใบลดหนี้แล้ว</div>
                  <div v-if="dataDetail.item.status === 4" style="color: #e449ff">สินค้ารอนำเข้าคลัง CN</div>
                </td>
                <td class="pa-3" width="15%">
                  <v-btn v-if="dataDetail.item.status === 0" @click="getReturn(dataDetail.item.doc_no)"
                    class="pa-6 grad-main-bg white--text" style="width: 100%;">
                    ส่งคืนแล้ว
                  </v-btn>
                  <v-btn v-if="dataDetail.item.status === 1"
                    @click="getReceipt(dataDetail.item.doc_no, dataDetail.item.issue_select)"
                    class="pa-6 grad-cancel-bg white--text" style="width: 100%;">
                    ใบลดหนี้/คืนสินค้า
                  </v-btn>
                  <v-btn v-if="dataDetail.item.status === 2" @click="getApprove(dataDetail.item.doc_no)"
                    class="pa-6 grad-danger-bg white--text" style="width: 100%;">
                    รออนุมัติ
                  </v-btn>
                </td>
                <td>
                  <v-btn v-if="dataDetail.item.status === 0" small height="42"
                    @click="getDetails(dataDetail.item.doc_no)" class="grad-success-bg white--text mr-1 mb-1"
                    title="ดูรายละเอียด">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn v-if="dataDetail.item.status !== 0" small height="42"
                    @click="getDetailsComplete(dataDetail.item.doc_no)" class="grad-success-bg white--text mr-1 mb-1"
                    title="ดูรายละเอียด">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn v-if="dataDetail.item.status === 0" small height="42" @click="getEdit(dataDetail.item.doc_no)"
                    class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไขข้อมูล">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn v-if="dataDetail.item.status === 0" small height="42"
                    @click="delete_receipt(dataDetail.item.return_doc_id)" class="grad-danger-bg white--text mr-1 mb-1"
                    title="ลบข้อมูล">
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="getPrinter(dataDetail.item.doc_no)"
                    class="grad-main-bg white--text mr-1 mb-1" title="พิมพ์">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-btn small height="42" @click="exportToExcel(dataDetail.item.doc_no)" class="white--text mr-1 mb-1"
                    style="background-color: #4CAF50;" title="Export Excel">
                    <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-dialog v-model="return_product" max-width="700">
          <v-card>
            <v-card-title class="justify-space-between">
              <div>ข้อมูลใบลดหนี้ / คืนสินค้า / เปลี่ยนสินค้า / อื่นๆ</div>
              <div style="cursor:pointer;" @click="return_product = false">
                <v-icon>mdi-close</v-icon>
              </div>
            </v-card-title>
            <v-divider />
            <div class="pa-5">
              <v-form ref="save_receipt" @submit.prevent="save_receipt">
                <div class="grid_full">
                  <div class="mr-1">
                    <v-text-field color="#86bc3a" label="เลขที่เอกสารตอบกลับจากซัพพลายเออร์"
                      v-model="send_data_modal.return_no" prepend-inner-icon="mdi-account-outline"
                      :rules="[v => !!v || 'กรุณากรอกเลขที่เอกสาร']" hide-details="auto" required
                      outlined></v-text-field>
                  </div>
                </div>
                <div class="grid_full mt-5">
                  <div class="mr-1">
                    <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                      :return-value.sync="send_data_modal.dateTH" transition="scale-transition" offset-y
                      min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field color="#86bc3a" v-model="send_data_modal.dateTH"
                          label="วันที่ใบส่งสินค้า (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่ใบส่งสินค้า']"
                          prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                      </template>
                      <v-date-picker locale="TH" color="#86bc3a" @change="diffDate_TH(send_data_modal.dateEN)"
                        v-model="send_data_modal.dateEN" :max="start_date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="selectDate()">
                          ตกลง
                        </v-btn>
                        <v-btn text color="primary" @click="menu_date = false">
                          ยกเลิก
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="grid_full mt-n1">
                  <div class="mr-1">
                    <v-text-field color="#86bc3a" label="หมายเหตุ" v-model="send_data_modal.return_note"
                      prepend-inner-icon="mdi-message-bulleted" :rules="[v => !!v || 'กรุณากรอกหมายเหตุ']"
                      hide-details="auto" required outlined></v-text-field>
                  </div>
                </div>
                <div class="grid_full mt-5" v-if="send_data_modal.issue_select == 0">
                  <div class="mr-1">
                    <v-text-field color="#86bc3a" label="ยอดชำระ" v-model="send_data_modal.total"
                      prepend-inner-icon="mdi-cash-multiple" :rules="[v => !!v || 'กรุณากรอกยอดชำระ']"
                      hide-details="auto" required outlined></v-text-field>
                  </div>
                </div>
                <div class="pa-1 text-center mt-5">
                  <v-btn x-large type="submit" class="grad-success-bg white--text"
                    style="font-size: 18px">บันทึกข้อมูล</v-btn>
                </div>
              </v-form>
            </div>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { diffDateTH, minDate } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Return_product_waitupdate",
  data() {
    return {
      loading_page: false,
      search: null,
      return_product: false,
      send_data_modal: {
        dateTH: '',
        dateEN: '',
        return_doc_id: '',
        return_no: '',
        return_note: '',
        issue_select: 0,
        total: '',
      },
      alert_success: false,
      alert_error: false,
      menu_date: false,
      start_date: this.min_date(),
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'เลขที่เอกสาร',
          value: 'doc_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'บริษัท',
          value: 'supplier_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'วันที่ส่งคืน',
          value: 'return_date',
          fixed: true,
          width: '140px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '125px',
        },
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '250px',
        },
      ],
      datalist: [],
    }
  },
  methods: {
    async selectDate() {
      this.$refs.menu_date.save(this.send_data_modal.dateTH)
      this.menu_date = false
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const date_th = day + '/' + month + '/' + year
      return this.send_data_modal.dateTH = date_th
    },
    diffTH: function (value) {
      return diffDateTH(value)
    },
    min_date: function () {
      return minDate()
    },
    get_all() {
      this.loading_page = true
      HTTP.post('/returnproductdocs/all')
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.datalist = res.data.object
          }
        })
    },
    exportToExcel(doc_no) {
      // แสดง loading
      Swal.fire({
        title: 'กำลังสร้างไฟล์ Excel...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      });

      // สร้าง URL สำหรับ download Excel
      const url = `https://www.pharmacare-plus.com/api/returnproductdocs/excel/${doc_no}`;

      // สร้างลิงก์ download ชั่วคราว
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // ปิด loading
      setTimeout(() => {
        Swal.close();
        Swal.fire({
          title: 'กำลัง Download',
          text: 'กำลัง Download ไฟล์ Excel...',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      }, 500);
    },
    getStatusText(status) {
      switch (status) {
        case '':
          return 'ไม่พบข้อมูล';
        case 0:
          return 'กำลังดำเนินการ';
        case 1:
          return 'ส่งคืนแล้ว';
        case 2:
          return 'ได้รับใบลดหนี้แล้ว';
        case 4:
          return 'สินค้ารอนำเข้าคลัง CN';
        default:
          return 'ไม่ระบุ';
      }
    },
    getDetails(id) {
      this.$router.push('/stock/document/documentdetails/' + id);
    },
    getDetailsComplete(id) {
      this.$router.push('/stock/document/documentdetailscomplete/' + id);
    },
    getEdit(id) {
      this.$router.push('/stock/document/governmentreceiptedit/' + id)
    },
    getReceipt(id, issue_select) {
      this.return_product = true;
      this.send_data_modal.dateTH = ''
      this.send_data_modal.dateEN = ''
      this.send_data_modal.return_doc_id = ''
      this.send_data_modal.return_no = ''
      this.send_data_modal.return_note = ''
      this.send_data_modal.return_doc_id = id
      this.send_data_modal.issue_select = issue_select
      this.send_data_modal.total = ''
    },
    getApprove(id) {
      Swal.fire({
        title: 'คุณต้องการอนุมัติการส่งคืนสินค้าหรือไม่ !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_success = true
          HTTP.post('/returnproductdocs/changesuccess', {
            return_doc_id: id,
            status: 3,
            user_login_id: this.$store.state.userDetail.id,
            user_name: this.$store.state.userDetail.name,
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_success = false
              this.get_all()
            }
          })
        }
      })
    },
    save_receipt() {
      if (this.$refs.save_receipt.validate()) {
        this.alert_success = true
        HTTP.post('/returnproductdocs/changeapprove', {
          return_doc_id: this.send_data_modal.return_doc_id,
          status: 4,
          return_no: this.send_data_modal.return_no,
          date_reduce: this.send_data_modal.dateEN,
          return_note: this.send_data_modal.return_note,
          total: this.send_data_modal.issue_select == 0 ? this.send_data_modal.total : null,
          user_login_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
        }).then((res) => {
          if (res.data.success === true) {
            this.return_product = false
            this.alert_success = false
            this.get_all()
          }
        })
      }
    },
    getPrinter(doc_no) {
      window.open('https://www.pharmacare-plus.com/returnpdf/' + doc_no, '_blank')
    },
    getReturn(id) {
      Swal.fire({
        title: 'คุณต้องการส่งคืนสินค้าหรือไม่ !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.alert_success = true
          HTTP.post('/returnproductdocs/change', {
            return_doc_id: id,
            status: 1,
            user_login_id: this.$store.state.userDetail.id,
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_success = false
              this.get_all()
            }
          })
        }
      })
    },
    delete_receipt(id) {
      Swal.fire({
        title: 'คุณต้องการลบใบส่งคืนสินค้าหรือไม่ !',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.alert_error = true
          HTTP.post('/returnproductdocs/delete', {
            return_doc_id: id
          }).then((result) => {
            if (result.data.success === true) {
              this.alert_error = false
              this.get_all()
            }
          })
        }
      })
    },
  },
  mounted() {
    this.get_all()
  }
}
</script>

<style scoped>
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
</style>
